// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"92ffd28f","195":"97dce240","655":"11909dbb","729":"97dce240"}[chunkId] + ".chunk.css";
};